import { RequestTraceInterceptor } from '@aca-new/app/shared/interceptors/request-trace.interceptor';
import { HttpBackend, HttpClient, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  public constructor(public readonly httpClient: HttpClient) {}
}

@Injectable({
  providedIn: 'root',
})
export class SkipInterceptorService {
  public readonly httpClient: HttpClient;

  private readonly _requestTraceInterceptor: RequestTraceInterceptor = new RequestTraceInterceptor();

  private readonly _traceHttpHandler: HttpHandler = {
    handle: <T>(request: HttpRequest<T>): Observable<HttpEvent<T>> => this._requestTraceInterceptor.intercept(request, this._handler),
  };

  public constructor(private readonly _handler: HttpBackend) {
    this.httpClient = new HttpClient(this._traceHttpHandler);
  }
}
